import { t } from 'i18next';

import { ErrorResponseErrorItemCodeProject } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeProject, string> => ({
  'project:folder_name_exists': t('project.folderNameExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'En mapp med samma namn existerar redan.',
  }),
  'project:not_found': t('project.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektet kunde inte hittas.',
  }),
  'project:invalid_status': t('project.invalidStatus', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektet har inte förväntad status.',
  }),
  'project:user_unauthorized': t('project.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte åtkomst till aktuellt projekt.',
  }),
  'project:coordinate_system_not_found': t('project.coordinateSystemNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektet saknar koordinatsystem.',
  }),
  'project:geoid_not_found': t('project.geoidNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektet saknar geoid.',
  }),
  'project:not_archived': t('project.notArchived', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektet är inte arkiverat.',
  }),
  'project:no_restorable_archive_job_exists': t('project.noRestorableArchiveJobExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'Det finns inget färdigt arkiveringsjobb att återställa.',
  }),
  'project:create_real_property_error': t('project.createRealPropertyError', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ett oväntat fel uppstod vid inköp av fastighetsgräns.',
  }),
  'project:create_real_property_timeout': t('project.createRealPropertyTimeout', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ett oväntat fel uppstod vid inköp av fastighetsgräns.',
  }),
  'project:get_real_properties_error': t('project.getRealPropertiesError', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ett oväntat fel uppstod vid sökning av fastigheter.',
  }),
  'project:get_real_properties_timeout': t('project.getRealPropertiesTimeout', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ett oväntat fel uppstod vid sökning av fastigheter.',
  }),
  'project:archive_job_not_found': t('project.archiveJobNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Arkiveringsjobb kunde inte hittas.',
  }),
  'project:current_archive_job_exists': t('project.currentArchiveJobExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ett aktuellt arkiveringsjobb existerar.',
  }),
  'project:current_restore_job_exists': t('project.currentRestoreJobExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'Ett aktuellt återställningsjobb existerar.',
  }),
  'project:archive_job_cannot_be_deleted': t('project.archiveJobCannotBeDeleted', {
    ns: 'apiErrorCodes',
    defaultValue: 'Arkiveringsjobbet kan inte tas bort.',
  }),
  'project:no_permission_to_set_archive_date': t('project.noPermissionToSetArchiveDate', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du saknar rättigheter att ange arkiveringsdatum.',
  }),
  'project:no_permission_to_add_archive_job': t('project.noPermissionToAddArchiveJob', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du saknar rättigheter att arkivera projektet.',
  }),
  'project:no_registered_dongles_exist': t('project.noRegisteredDonglesExist', {
    ns: 'apiErrorCodes',
    defaultValue: 'Inga registrerade enheter existerar.',
  }),
  'project:has_no_drone_harmony_integration': t('project.droneHarmonyIntegrationNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektet har ingen Drone Harmony-integration.',
  }),
  'project:drone_harmony_integration_already_exists': t(
    'project.droneHarmonyIntegrationAlreadyExists',
    { ns: 'apiErrorCodes', defaultValue: 'Projektet har redan en Drone Harmony-integration.' },
  ),
  'project:drone_harmony_flight_plan_not_found': t('project.droneHarmonyFlightPlanNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Flygrutten kunde inte hittas för Drone Harmony-integrationen.',
  }),
  'project:drone_harmony_no_access_to_flight_plan': t('project.droneHarmonyFlightPlanNotOwner', {
    ns: 'apiErrorCodes',
    defaultValue:
      'Flygrutten kan inte kopplas eftersom den inte tillhör samma användare som satte upp Drone Harmony integrationen i SkyMap.',
  }),
  'project:user_invitation_not_found': t('project.userInvitationNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Projektinbjudan hittades inte.',
  }),
  'project:user_invitation_does_not_match_project': t('project.userInvitationDoesNotMatchProject', {
    ns: 'apiErrorCodes',
    defaultValue: 'Inbjudningen är inte för detta projekt.',
  }),
  'project:boundary_polygon_not_found': t('project.boundaryPolygonNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Fastighetsgränsen kunde inte hittas.',
  }),
});
